/* "Make it a party" upsell. Added by Oleg @ IAKOE.
   ADD ALL adds every card's product (data-items JSON) to the cart through the
   kit's window.iaCartAPI (publishes cart events → the drawer content refreshes)
   and opens the cart drawer. */
if (!customElements.get('ts-party')) {
  customElements.define(
    'ts-party',
    class TsParty extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        this._button = this.querySelector('.ts-party__add');
        this._button?.addEventListener('click', () => this.addAll());
      }

      async addAll() {
        let items;
        try {
          items = JSON.parse(this.dataset.items);
        } catch (e) {
          return;
        }
        if (!window.iaCartAPI || !items || !items.length) return;

        this._button.classList.add('adding');
        try {
          const cartObj = await window.iaCartAPI.addToCartJson({ items });
          document.querySelector('ia-cart')?.open(cartObj);
        } catch (error) {
          console.error('ts-party add all failed:', error);
        } finally {
          this._button.classList.remove('adding');
        }
      }
    }
  );
}
